import { render } from "./CalendarYearView.vue?vue&type=template&id=2edb9798&scoped=true"
import script from "./CalendarYearView.vue?vue&type=script&lang=js"
export * from "./CalendarYearView.vue?vue&type=script&lang=js"

import "./CalendarYearView.vue?vue&type=style&index=0&id=2edb9798&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edb9798"]])

export default __exports__